export enum UNF_CHOICE {
  RISIKOGRUPPE = 'risikogruppe',
  PROGRESSION = 'progression',
  KRANKENTAGEGELD_AB_TAG = 'unfKrankentagegeldAbTag',
  BERGUNGSKOSTEN = 'bergungskosten',
  OPERATIONEN = 'operationen',
}

export enum UNF_META {
  BERGUNGSKOSTEN = 'hasBergungskosten',
  OPERATIONEN = 'hasOperationen',
  KRANKENTAGEGELD_AB_TAG_NICHT_GEWUENSCHT = 'krankentagegeldAbTagNichtGewuenscht',
}
